<template>
	<div>
		<bw-table
				aria-label="data-table"
				:headers="headers"
				hide-row-select
				:items="users"
		>
			<!-- keep the slot -->
			<!-- TODO: Add color to status -->
			<template v-slot:item.email="{ item: user }">
				<a :href="`mailto:${user.email}`">{{ user.email }}</a>
			</template>
			<template v-slot:item.created_at="{ item: user }">
				{{ new Date(user.created_at).toLocaleDateString() }}
			</template>
			<template v-slot:item.actions="{ item: user }">
				<div class="d-flex">
					<v-btn
							color="secondary"
							depressed
							fab
							outlined
							small
							@click="viewUser(user)"
					>
						<v-icon small>mdi-eye-outline</v-icon>
					</v-btn>
				</div>
			</template>
		</bw-table>

		<create-message
				:showDialog="showDialog"
				:recipients="newMessage.recipients"
				:users="[]"
				:new-message="newMessage"
				@resetMsg="resetMsg"
		></create-message>
	</div>
</template>

<script>
export default {
	name: 'ListUsers',
	props: {
		usersData: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			// From here or passed from blade file to props
			headers: [
				{
					align: 'start',
					mandatory: true,
					text: 'Name',
					value: 'name'
				},
				{
					align: 'start',
					selected: true,
					text: 'Email',
					value: 'email'
				},
				{
					align: 'start',
					filterOn: 'roleName',
					selected: true,
					text: 'Role',
					value: 'roleName',
					width: 'auto'
				},
				{
					align: 'center',
					selected: true,
					sortable: false,
					text: 'Created',
					value: 'created_at',
					width: '15%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			users: this.usersData,
			newMessage: {},
			showDialog: false
		};
	},
	computed: {
		avatarSize() {
			if(this.$vuetify.breakpoint.xsOnly) return 36;
			if(this.$vuetify.breakpoint.smOnly) return 40;
			if(this.$vuetify.breakpoint.mdOnly) return 44;
			return 48;
		}
	},
	created() {
	},
	mounted() {
		this.resetMsg();
	},
	methods: {
		viewUser(user) {
			window.location.href = `/partner-portal/${this.partner.id}/users/edit-user/${user.id}`;
		},
		showInviteMsg(selectedRows) {
			this.newMessage.recipients = selectedRows;
			this.newMessage.subject = 'You have been invited to join ' + this.partner.name + '\'s network.';
			this.newMessage.message = "You have been invited to join " + this.partner.name + "'s network.<br>Click the link below it get started.<br>{{newInviteUrl}}";
			this.showDialog = true;
		},
		resetMsg() {
			this.newMessage = { recipients: [], disableRecipients: true, canTest: true };
		}
	}
};
</script>

<style lang="scss" scoped></style>
